import "./Services.scss";
import { Link } from "react-router-dom";
import React from "react";

export default function Services() {
    return (
        <div className="services">
            <div className="services__container">
                <h1 className="services__container__title">НАШІ ПОСЛУГИ</h1>
                <div className="services__container__item">
                    <Link className="services__container__item__bg1" to="completion-of-krn" />
                    <div className="services__container__item__right">
                        <span className="services__container__item__right--text">Реставрація та доукомплектація КРН, Сівалок</span>
                        <span className="services__container__item__right--under-text">Замість більш витратної за часом та вартістю купівлі нової сільськогосподарської машини більш рентабельною є реставрація КРН</span>
                        <button className="services__container__item__right--button">ДЕТАЛЬНІШЕ</button>
                    </div>
                </div>
                <div className="services__container__item">
                    <div className="services__container__item__left">
                        <span className="services__container__item__left--text">Обприскування дронами</span>
                        <span className="services__container__item__left--under-text">Послуги з обприскування полів дронами у Вінниці</span>
                        <button className="services__container__item__left--button">ДЕТАЛЬНІШЕ</button>
                    </div>
                    <Link className="services__container__item__bg2" to="drone-spraying" />
                </div>
            </div>
        </div>
    );
}